import React from 'react';
import { Grid, Autocomplete, TextField, Button } from '@mui/material';

const PatientDetailsScatterPlotSelector = ({
  classes,
  scatterplotOptions = [],
  selectedOption,
  setSelectedOption,
  onSubmit,
}) => (
  <Grid container spacing={2}>
    <Grid item xs={12} sm={8}>
      <Autocomplete
        fullWidth
        className={classes?.muiInputs}
        options={scatterplotOptions}
        getOptionLabel={option => option.plotOptionLabel}
        value={selectedOption || null}
        onChange={(event, newValue) => setSelectedOption(newValue)}
        renderInput={params => (
          <TextField {...params} label="Select Scatterplot" variant="outlined" size="small" />
        )}
        isOptionEqualToValue={(option, value) => option.codeString === value?.codeString}
      />
    </Grid>
    <Grid item xs={12} sm={4}>
      <Button
        fullWidth
        variant="contained"
        onClick={() => onSubmit(selectedOption)}
        disabled={!selectedOption}
      >
        Submit
      </Button>
    </Grid>
  </Grid>
);

export default PatientDetailsScatterPlotSelector;